import styled from 'styled-components'

/**
 * Strong component to make the text bold
 */
export const Strong = styled.strong`
	font-weight: var(--font-weight-bold);
`
